import { Box, styled } from "@mui/material";
import { colors, transitions } from "../../styles/theme";
import { convertToBreakpoints } from "../../utils/fuilds";
import { BREAKPOINT_MOBILE } from "../../constants";
import { deviceStyles } from "../../hooks/useDeviceStyles";

export const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  margin: 'auto',
  position: "relative",
  minWidth: 0,
  /*@TODO scale*/
  // padding: '0 25px',
  // overflow: "hidden",
  transition: transitions.join(["opacity"]),
}));

export const ArrowControlCommon = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  cursor: "pointer",
  userSelect: "none",
  zIndex: 2,
  // background: 'yellow',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  svg: {
    cursor: "pointer",
    color: colors.text.v3,
    transition: transitions.join("color")
  },
  [theme.breakpoints.down(BREAKPOINT_MOBILE)]: {
    svg: {
      color: colors.text.v4,
    },
  },
  [theme.breakpoints.up(BREAKPOINT_MOBILE)]: {
    height: '100%',
    width: '30px',
  },
  "&:hover": {
    svg: {
      color: colors.text.v4
    }
  },
  "&.left": {
    left: 0,
  },
  "&.right": {
    right: 0,
  },
  // ...deviceStyles({
  //   mobile: {
  //     svg: {
  //       width: '6px',
  //     }
  //   }
  // }, [
  //   {
  //     svg: {
  //       width: '22px',
  //       height: '30px',
  //     }
  //   },
  //   undefined,
  //   undefined,
  //   {
  //     svg: {
  //       width: '32px',
  //       height: '50px',
  //     }
  //   }
  // ])
}));